import React from 'react';
import { useNavHeightContext } from 'common/contexts/NavHeightContext';
import { MobileMenu } from './MobileNav/MobileMenu';

interface Props {
  isMenuOpen: boolean;
  handleMenuOpen: () => void;
  children?: React.ReactNode;
}

export const MobilePageTemplate: React.FC<Props> = (props) => {
  const { isMenuOpen, handleMenuOpen, children } = props;

  const { marginTop } = useNavHeightContext();

  const content = isMenuOpen ? <MobileMenu handleMenuOpen={handleMenuOpen} /> : children;

  return <div style={{ marginTop: `${marginTop}px` }}>{content}</div>;
};
MobilePageTemplate.displayName = 'MobilePageTemplate';
